export enum Tab {
    Artists = 'artists',
    Events = 'events',
    Date = 'date',
    Category = 'category',
    MainCategory = 'mainCategory',
    Country = 'country',
    City = 'city',
}
